
<h2>Categorías</h2>
<hr /><br />
<ul class="list-group">
  <li *ngFor="let item of categories"
      class="list-group-item">
    {{ item.Name }}
  </li>
</ul>
